var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.click}},[(!_vm.avatar)?_c('div',{class:['user-wrapper', { 'is-login': _vm.isLogin }]},[_c('i',{staticClass:"user-icon icon-outline_personalcenter"})]):_c('img',{staticClass:"header-logo",attrs:{"src":_vm.avatar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }